<div class="device-dialog">
    <div class="mat-h1">
      Delete file?
    </div>
    <mat-dialog-actions align="end">
        <button mat-button color="primary" (click)="onCancel()" mat-dialog-close>NO, GO BACK</button>
        <button mat-button color="primary"   (click)="removeFile()">YES, DELETE</button>
     </mat-dialog-actions>
</div>